import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../core/Icon";
export const PageNotFound = () => {
    return (React.createElement("div", { className: "message-block" },
        React.createElement("div", { className: "message text-center" },
            React.createElement(Icon, { c: ['website-problem', 64, 64] }),
            React.createElement("h1", null, "Strana neexistuje"),
            React.createElement("p", null, "Str\u00E1nka na kterou se pokou\u0161\u00EDte p\u0159istoupit ji\u017E neexistuje, nebo byla p\u0159esunuta."),
            React.createElement(Link, { className: "primary-button", to: "/cs/seznam/nejblizsi-aukce" }, "Na hlavn\u00ED stranu"))));
};
